// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vrw97cJxMo7JsVdGuyFF {
  width: 30em;
}
.vrw97cJxMo7JsVdGuyFF > h1 {
  text-transform: uppercase;
  font-size: 1.2em;
  font-weight: 600;
  margin-bottom: 1em;
}
.vrw97cJxMo7JsVdGuyFF > ul {
  display: flex;
  gap: 0.5em;
}
.vrw97cJxMo7JsVdGuyFF > ul li:first-child {
  flex: 80% 0 0;
}
.vrw97cJxMo7JsVdGuyFF input[name="username"] {
  display: none;
}
.vrw97cJxMo7JsVdGuyFF .username {
  visibility: hidden;
  overflow: hidden;
  height: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `vrw97cJxMo7JsVdGuyFF`,
	"username": `username`
};
export default ___CSS_LOADER_EXPORT___;
